import { render, staticRenderFns } from "./benefits-empty-state.vue?vue&type=template&id=3768654c&scoped=true"
import script from "./benefits-empty-state.vue?vue&type=script&lang=js"
export * from "./benefits-empty-state.vue?vue&type=script&lang=js"
import style0 from "./benefits-empty-state.vue?vue&type=style&index=0&id=3768654c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3768654c",
  null
  
)

export default component.exports